// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stats.all[data-v-494e85d4]{grid-template-columns:1fr 1fr 1fr 1fr}.stats.euro[data-v-494e85d4]{grid-template-columns:1fr 1fr}.stats.euro.all[data-v-494e85d4]{grid-template-columns:1fr 1fr 1fr}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
